// src/components/sections/TestimonialsSection.js
import React from 'react';
import { motion } from 'framer-motion';
import TestimonialCard from '../cards/TestimonialCard';
import testimonialsData from '../../data/testimonials';

// Animation variants for the container to orchestrate staggered animations.
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

// Animation variants for each individual testimonial card.
const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
};

/**
 * TestimonialsSection component displays customer testimonials with entrance animations.
 * @return {React.ReactElement} The TestimonialsSection component.
 */
const TestimonialsSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Отзывы <span className="text-orange-500">Клиентов</span>
          </h2>
        </motion.div>

        <motion.div
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {testimonialsData.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} variants={itemVariants} />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
